import { render } from "./CreateServiceModal.vue?vue&type=template&id=0dda77d6"
import script from "./CreateServiceModal.vue?vue&type=script&lang=js"
export * from "./CreateServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__